const initialProps = {
  currentComponent: {},
};

export default function (state = initialProps, action) {
  switch (action.type) {
    case "UPDATE_CURRENT_COMPONENT":
      return {
        ...state,
        currentComponent: action.payload,
      };
    default:
      return state;
  }
}
